const Messages = {
  Success: {
    Saved: 'Сохранено',
    Rejected: 'Отменено',
    PasswordChanged: 'Пароль успешно поменялся',
    ActivationSuccessful: 'Активация завершилась успешно',
    CheckYourEmailToCompleteReg: 'Подтвердите ваш email для окончания регистрации',
    Copied: 'Фильтр успешно скопирован',
    NotCopiedFilterNotSet: 'Не скопировано. Фильтр не установлен',
    DocumentsPassed: 'Документы проведены',
    DocumentsUnpassed: 'Проведение документов отменено',
  },

  Errors: {
    PageSize: '`pageSize` должен быть положительным целым числом больше нуля',
    ErrorWhileRequest: 'Произошла ошибка при получении данных. {0}',
    ErrorWhileRequestTotal: 'Произошла ошибка при получении данных итоговой строки. {0}',
    FormNotFound: 'Форма {0} не найдена',
    UnsupportedFieldType: 'Неподдерживаемый тип поля - {0}',
    FieldIsRequired: 'Поле {0} обязательное',
    FilterNotSet: 'Фильтр не установлен',
    FilteringRulesError: 'Filtering rules are not defined!',
    CopingRulesError: 'Coping rules are not defined!',
    LoginValidMsg: 'Поле не должно быть пустым или содержать пробелы.',
    FieldsAreRequired: 'Поля обязательные к заполнению: {0}',
    PassValidMsg: 'Поле не должно быть пустым или содержать менее 6 символов.',
    CustomFontsLoadingError: 'Не удалось загрузить пользовательские шрифты',
    RequiredFiltersEmpty: 'Обязательные фильтры не заполнены',
    FiltersAreRequired: 'Обязательные фильтры к заполнению: {0}',
    SmallPassword: 'Ваш пароль должен быть более {0} знаков',
    IsEmptyBodyFilter: 'Вы пытаетесь сохранить пустой фильтр',
    RecordNotFound: 'Записи не найдены.',
    EmailIsRequired: 'Поле email должно быть заполнено',
    PassAndConfirmDifferent: 'Пароли не совпадают',
    PassAndConfirmRequired: 'Поля password и confirmation обязательны',
    PassRequired: 'Поле password должно быть заполнено',
    ConfirmRequired: 'Требуется подтверждение пароля',
    ResponseEmpty: 'Response is empty.',
    AtLeastOneRowMustBeSelected: 'Выберите хотя бы одну строку',
    FilteringRulesAreNotDefined: 'Правила фильтрации не определены',
    OnlyOneSelectedRowAllowedForThisAction:
      'Поле назначения не поддерживает множественный выбор. Для данной операции должна быть выбрана только одна строка',
    ListFormAndTreeViewSubFormsTypes:
      'Только сабформы типа `ListForm`, `TreeView`, `EditForm` и `FreeForm` разрешены для форм типа `ListForm` и `TreeView`',
    EditFormAndFreeFormSubFormsTypes:
      'Только сабформы типа `ListForm`, `TreeView`, `EditForm` и `FreeForm` разрешены для форм типа `EditForm` и `FreeForm`',
    ReportFormAndMultiEditFormSubFormsTypes: 'Сабформы для форм типа `ReportForm` и `GroupEditForm` не разрешены',
    EmptyRespInGetEditFormDataFunc: 'Empty response in getEditFormData function',
    IsRequired: 'не заполнено',
    AreRequired: 'не заполнены',
    SpacesError: 'не может содержать пробел',
    IsIncorrect: 'неверное',
    ErrorSymbols: 'Не допустимые символы в поле {0}',
    NoFormAttached: 'Для данной операции нет прикрепленной формы',
    InvalidDate: 'Не правильный формат даты',
    DateToMustBeLess: 'Дата конца должна быть меньше даты начала',
    WhileDeletingRow: 'Ошибка при удалении строки',
    AtLeastOneTabMustBeVisible: 'Должна быть видима хотя бы одна закладка',
    AtLeastOneButtonMustBeVisibleInToolbar: 'Должна быть видима хотя бы одна кнопка в тулбаре',
    AtLeastOneButtonMustBeVisibleInMenu: 'Должна быть видима хотя бы одна кнопка в меню',
    AtLeastOneColumnMustBeVisible: 'Должна быть видима хотя бы одна колонка',
    AtLeastOneBoardMustBeVisible: 'Должна быть видима хотя бы одна доска',
    InvalidDateEntered: 'Неверно введена дата.',
    ErrorOccurred: 'Произошла ошибка',
    InvalidFilter: 'Сохранённый фильтр - некорректный. Пожалуйста, пересоздайте его.',
    ClientScriptInitializationError: 'Ошибка инициализации клиентского скрипта',
    ParentFormError: 'Может вызываться только на родительской форме, но не на сабформе.',
    GroupDoesNotExist: 'Этой группы {0} не существует',
    ButtonDoesNotExist: 'Кнопки {0} не существует',
  },

  Warning: {
    ChangeFilterInUserScript:
      'В пользовательских скриптах запрещено менять ' +
      'фильтр пока таблица находится в режиме редактирования. Фильтр не применился.',
    CustomParamByFN: 'Поле `{0}`, указанное в `CustomParameters`, не найдено на форме.',
    EditNestedDataOnlyInInlineMode: 'Редактирование вложенных объектов возможно только в строке.',
    OnSaveRowDeprecated: 'Метод `onSaveRow` устарел, используйте `onRowBeforeSave` взамен.',
    OnInitializedDeprecated: 'Метод `onInitialized` устарел, используйте `onBeforeEditRow` взамен.',
    OnMasterSelectFilterDeprecated: 'Метод `OnMasterSelectFilter` устарел, используйте `onMasterSelectFilter` взамен.',
    OnBeforeGetDataFilterDeprecated: 'Метод `OnBeforeGetData` устарел, используйте `onBeforeGetData` взамен.',
    AllColumnsDisabledForReordering: 'Изменения порядка колонок запрещено.',
    LoadAllWarningMessage: 'Отображено первые `{0}` строк. Уточние условие отбора данных',
    FormWithoutElements: 'Невозможно открыть форму без элементов',
  },

  Confirm: {
    RowsDelete: 'Удалить выделенные записи?',
    SaveChanges: 'Сохранить внесенные изменения?',
    ResetAllSettings: 'Вы уверены что хотите сбросить все настройки?',
    ClearQuickFilters: 'Вы действительно хотите очистить все примененные параметры фильтрации?',
    SetIsPassed: 'Вы хотите провести документ?',
    ClearIsPassed: 'Вы хотите отменить проведение документа?',
    ChangeFilter: 'Вы действительно хотите заменить фильтр?',
    ChangeFavorite: 'Вы действительно хотите убрать признак "избранный фильтр"?',
    DeleteFilter: 'Вы действительно хотите удалить сохраненный фильтр?',
  },

  Message: {
    EnterLoginAndPass: 'Введите логин и пароль',
    Deleted: 'Удалено',
    SingIn: 'Войти в свой аккаунт',
    EnterFilterName: 'Введите название фильтра',
    CheckYourEmail: 'Проверьте вашу почту для окончания процедуры восстановления пароля',
    Count: 'КОЛИЧЕСТВО',
    Avg: 'СР.ЗНАЧЕНИЕ',
    Sum: 'СУММА',
    Min: 'МИН',
    Max: 'МАКС',
    FilterAddedToFavorite: 'Фильтр добавлен в "Избранное"',
    FilterRemovedFromFavorite: 'Фильтр удален из "Избранного"',
    FilterSetAsDefault: 'Фильтр установлен фильтром по умолчанию',
    FilterSetAsRegular: 'Фильтр больше не является фильтром по умолчанию',
    FilterChanged: 'Фильтр заменен',
    FilterRemoved: 'Фильтр удален',
    FilterNameChanged: 'Имя фильтра изменено',
    WeCanNotFindPage: 'Кажется, мы не можем найти страницу, которую вы ищете.',
    SomethingWentWrong: 'Что-то пошло не так!',
    HereHelpfulLinks: 'Некоторые полезные ссылки:',
    ErrorCode404: 'Код ошибки: 404',
    Help: 'Помощь',
    UserSettings: 'Пользовательские настройки',
    Notifications: 'Уведомления',
    Profile: 'Профиль',
  },

  Controls: {
    Home: 'На главную',
    SingIn: 'Войти',
    SingOut: 'Выйти',
    SingUp: 'Регистрация',
    Login: 'Логин',
    ForgotPassword: 'Забыли пароль?',
    Name: 'Имя',
    Email: 'Почта',
    Password: 'Пароль',
    Cancel: 'Отмена',
    Close: 'Закрыть',
    Clear: 'Очистить',
    Yes: 'Да',
    No: 'Нет',
    All: 'Все',
    On: 'Вкл',
    Off: 'Выкл',
    OK: 'OK',
    OR: 'или',
    Confirmation: 'Подтверждение',
    SelectAll: 'Выделить все',
    Select: 'Выбрать',
    SelectValue: 'Выбрать значение',
    SelectAllHint: 'Выделение всех строк таблицы',
    ShowTableFilterRow: 'Показать/Спрятать строку фильтрации',
    UserSettings: 'Пользовательские настройки',
    GeneralSettings: 'Общие настройки',
    TablesTreesSettings: 'Настройки таблиц и деревьев',
    EditorStylingMode: 'Режим стилей редакторов',
    Filter: 'Фильтр',
    SaveCurrentFilter: 'Сохранить текущий фильтр',
    FilterManager: 'Менеджер фильтров',
    CopyFilterAsURL: 'Копировать фильтр как ссылку',
    ChangeFilter: 'Изменить фильтр',
    LoadAll: 'Загрузить все',
    Report: 'Отчет',
    ReportGroup: 'Группа отчетов',
    DeselectAll: 'Отменить выделение всего',
    DeselectAllHint: 'Отмена выделения всех строк таблицы',
    LoadingPanel: 'Загрузка...',
    SaveAndClose: 'Сохранить и закрыть',
    Apply: 'Применить',
    RegionalSettings: 'Региональные настройки',
    CommonSettings: 'Общие',
    ResetAllSettings: 'Сбросить все настройки',
    ColumnChooser: 'Выбор колонок',
    Settings: 'Настройки',
    TabSettings: 'Настройки закладок',
    CalcTotals: 'Итоговая строка',
    CalcTotalsNone: 'Отключена',
    CalcTotalsNoneHint: 'Расчет итоговой строки отключен',
    CalcTotalsBySelected: 'По выделенным',
    CalcTotalsBySelectedHint: 'Рассчитать итоговую строку по выбранным записям',
    CalcTotalsAllData: 'По всем данным',
    ResetAllSettingsHint: 'Сбросить все пользовательские настройки',
    Add: 'Добавить',
    Edit: 'Редактировать',
    View: 'Просмотр',
    Delete: 'Удалить',
    Copy: 'Копировать',
    Refresh: 'Обновить',
    IsBlank: 'Пусто',
    IsNotBlank: 'Не пусто',
    IsAnyOf: 'Любой из',
    IsNotAnyOf: 'Ни один из',
    Preferences: 'Настройки',
    Export: 'Экспорт',
    ExportAll: 'Экспорт всех данных',
    ExportSelected: 'Экспорт выбранных записей',
    Rename: 'Переименовать',
    SaveWithOutClose: 'Сохранить без закрытия',
    Save: 'Сохранить',
    Discard: 'Отменить',
    Send: 'Отправить',
    SendRequest: 'Отправить запрос',
    ApplicationLanguage: 'Язык приложения',
    Appearance: 'Внешний вид',
    ApplicationTheme: 'Тема приложения',
    DrawerTheme: 'Тема панели навигации',
    SystemToolbarTheme: 'Тема системной панели',
    ApplicationDrawerSide: 'Положение меню',
    DrawerSideLeft: 'Слева',
    DrawerSideRight: 'Справа',
    Format: 'Формат',
    ClearQuickFilters: 'Очистить все примененные параметры фильтрации',
    ClearAll: 'Очистить все',
    RememberMe: 'Запомнить меня',
    SetIsPassed: 'Провести документ',
    ClearIsPassed: 'Отменить проведение документа',
    AddChild: 'Добавить дочернюю запись',
    ShowMore: 'Показать больше',
    ShowTitle: 'Показывать текст',
    More: 'Еще',
    OpenInNewTab: 'Открыть в новой вкладке',
    Open: 'Открыть',
    CopyText: 'Скопировать текст',
    Blank: '(Пусто)',
    Today: 'Сегодня',
    StartWork: 'Начало работы',
    CreateProject: 'Создание проектов',
    Orders: 'Работа с заказами',
    Groups: 'Группы',
    CreateList: 'Создание списков',
    Toolbar: 'Тулбар',
    Menu: 'Меню',
    Filters: 'Работа с фильтрами',
    EditFilters: 'Редактирование фильтров',
    Documentation: 'Вся документация',
    ProfileSettings: 'Настройки профиля',
    GoBack: 'Назад',
    GoToMenu: 'Вернуться в меню',
    HideColumn: 'Спрятать колонку',
    UnfixColumns: 'Открепить колонки',
    SortAscending: 'Сортировка по возростанию',
    SortDescending: 'Соритровка по убыванию',
    ClearSorting: 'Очистить сортировку',
    ClearFiltering: 'Очистить фильтр',
    Unfix: 'Открепить',
    FixColumnsToTheLeft: 'Закрепить колонки влево',
    FixToTheLeft: 'Закрепить влево',
    FixToTheRight: 'Закрепить вправо',
    DefaultFilter: 'Фильтр по умолчанию',
    Favorite: 'В избранные',
    ModifyDate: 'Дата редактирования',
    NewFilter: 'Новый фильтр',
    ShowFilterDockPanel: 'Показать панель фильтрации',
    ShowEditDockPanel: 'Показать панель редактирования',
    CustomizeFields: 'Настроить поля',
    ShowFields: 'Показывать поля',
    Default: 'Стандартные',
    SavedFilters: 'Сохраненные фильтры',
    SmallRowSize: 'Маленький',
    MediumRowSize: 'Средний',
    LargeRowSize: 'Большой',
    RowSizes: 'Размер строк',
    Columns: 'Колонки',
    Tabs: 'Закладки',
    Buttons: 'Кнопки',
    Other: 'Другие',
    Value: 'Значение поля',
    Values: 'Значения полей',
    Search: 'Поиск',
    Sections: 'Разделы',
    Favorites: 'Избранное',
    EmptyListText: 'Избранные фильтры отсутствуют',
    InterfaceSize: 'Размер интерфейса',
    Language: 'Язык',
    SelectCamera: 'Выберете камеру',
    Contains: 'Поиск по вхождениям',
    StartsWith: 'Поиск по первым символам',
    ByWords: 'Поиск по словам',
    Help: 'Справка',
    Details: 'Подробнее',
    Equals: 'Равно',
    DoesNotEquals: 'Не равно',
    LessThan: 'Меньше чем',
    GreaterThan: 'Больше чем',
    LessOrEqualTo: 'Меньше или равно',
    GreaterOrEqualTo: 'Больше или равно',
    Between: 'В промежутке',
    ContainsSmth: 'Содержит',
    StartsWithSmth: 'Начинается',
    ByWordsSearch: 'По словам',
    Boards: 'Доски',
    AllVisible: 'Все видимые',
    ClearValueMode: 'Режим очистки значений',
    HorizontalSeparatorLines: 'Горизонтальные разделительные линии',
    VerticalSeparatorLines: 'Вертикальные разделительные линии',
    AlternativeLinesColor: 'Альтернативный цвет строк',
    DefaultSt: 'По умолчанию',
    Show: 'Показывать',
    Hide: 'Не показывать',
    PreviewFile: 'Просмотр файла',
  },
  AdditionalText: {
    YouDontHaveNotifications: 'У вас нету уведомлений',
    UnsavedChanges: 'У вас есть несохраненные изменения! Вы хотите сохранить или отменить эти изменения?',
    UseYourAccount: 'или используйте Ваш аккаунт',
    EnterYourDetails: 'Введите ваши персональные данные и начните путешествие с нами',
    NewPassword: 'Новый пароль',
    ToKeepConnected: 'Что бы продолжить работу, зайдите под своими персональными данными',
    WelcomeBack: 'С возвращением!',
    CreateAccount: 'Создать аккаунт',
    RestorePassword: 'Восстановить пароль',
    ByDefault: 'По умолчанию',
    InSubsystem: 'В подсистеме',
    ModifyDate: 'Дата редактирования',
    D5: 'D5',
    Insert: 'Добавление',
    Edit: 'Редактирование',
    View: 'Просмотр',
    ResourceNotFound: 'Ресурс не найдено',
  },
};

export default Messages;
